import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {WriteReviewDialogComponent} from '@app/product/details/review/write-review/write-review-dialog/write-review-dialog.component';
import {CcRestrictedCountryIframeComponent} from '@app/shared/select-type/cc-restricted-country-iframe/cc-restricted-country-iframe.component';
import {MobileSearchNavBarComponent} from '@app/search/results/search-navigation-bar/mobile-facet-filter/mobile-search-nav-bar.component';
import {CyberSourceThreedsDialogComponent} from '@app/payment/components/cybersource/cyber-source-threeds-dialog/cyber-source-threeds-dialog.component';
import {
  RemoveCreditCardDialogComponent
} from '@app/digital-native-checkout/payment-method-display/payment-method-creditcard/remove-credit-card-dialog/remove-credit-card-dialog.component';
import {SapEmployeePopupComponent} from '@app/sap-employee-popup/sap-employee-popup.component';

export const dialogLayoutConfig: LayoutConfig = {
  launch: {
    SAP_EMPLOYEE_WARNING: {
      inlineRoot: true,
      component: SapEmployeePopupComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    WRITE_REVIEW: {
      inlineRoot: true,
      component: WriteReviewDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CC_RESTRICTED: {
      inlineRoot: true,
      component: CcRestrictedCountryIframeComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    SEARCH_NAVBAR: {
      inlineRoot: true,
      component: MobileSearchNavBarComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CYBERSOURCE_3DS_IFRAME: {
      inlineRoot: true,
      component: CyberSourceThreedsDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    REMOVE_CC_DIALOG: {
      inlineRoot: true,
      component: RemoveCreditCardDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    }
  },
};
